// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var SectionFeedback = function (x) {
    return x;
};
var tsBridgeSectionFeedback = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("SectionFeedback")("__brandSectionFeedback"));
    }
};
var writeSectionFeedback = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showSectionFeedback = Data_Show.showString;
var readSectionFeedback = Simple_JSON.readString;
var ordSectionFeedback = Data_Ord.ordString;
var newtypeSectionFeedback = {
    Coercible0: function () {
        return undefined;
    }
};
var makeSectionFeedback = SectionFeedback;
var eqSectionFeedback = Data_Eq.eqString;
export {
    SectionFeedback,
    makeSectionFeedback,
    unwrap,
    newtypeSectionFeedback,
    eqSectionFeedback,
    ordSectionFeedback,
    showSectionFeedback,
    readSectionFeedback,
    writeSectionFeedback,
    tsBridgeSectionFeedback
};
//# sourceMappingURL=index.js.map
